import { useEffect, useMemo, useState } from "react";
import { Download, Printer, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, downloadFile } from "@/lib/api";
import { ResultsGroup } from "@/components/fly/ResultsGroup";
import { ScoreBreakdownDialog } from "@/components/fly/ScoreBreakdownDialog";
import { FilterSelect, uniq, SearchInput, normText } from "@/components/fly/FilterSelect";

export const ResultsTab = ({ onChange }) => {
  const [groups, setGroups] = useState([]);
  const [day, setDay] = useState("all");
  const [cat, setCat] = useState("");
  const [age, setAge] = useState("");
  const [q, setQ] = useState("");
  const [detail, setDetail] = useState(null);
  const [judges, setJudges] = useState([]);

  const load = () => api.get("/admin/results").then((r) => setGroups(r.data));
  useEffect(() => { load(); api.get("/config").then((r) => setJudges(r.data.judges)); }, []);

  const days = useMemo(() => [...new Set(groups.map((g) => g.day))], [groups]);
  const inDay = groups.filter((g) => day === "all" || g.day === day);
  const needle = normText(q.trim());
  const shown = inDay
    .filter((g) => (!cat || g.category === cat) && (!age || g.age_group === age))
    .map((g) => (needle ? { ...g, entries: g.entries.filter((e) => normText(e.name).includes(needle) || normText(e.school).includes(needle)) } : g))
    .map((g) => (needle ? { ...g, scored: g.entries.filter((e) => e.complete).length } : g))
    .filter((g) => g.entries.length);

  const exportCsv = async () => {
    try {
      await downloadFile({ path: "/admin/results.csv", filename: "wyniki-fly-cup.csv" });
    } catch (e) { toast.error(errMsg(e)); }
  };

  const ctl = "h-11 px-3 rounded-xl bg-[#1C2541] border border-blue-500/20 text-sm outline-none focus:border-blue-500";
  return (
    <div className="mt-4">
      <div className="flex flex-wrap gap-2 no-print">
        <SearchInput testid="results-search-input" value={q} onChange={setQ} />
        <select data-testid="results-day-select" value={day} onChange={(e) => { setDay(e.target.value); setCat(""); setAge(""); }} className={ctl}>
          <option value="all">Wszystkie dni</option>
          {days.map((d) => <option key={d} value={d}>{d}</option>)}
        </select>
        <FilterSelect testid="results-filter-category" className="flex-1 min-w-[200px]" value={cat} onChange={setCat} options={uniq(inDay.map((g) => g.category))} placeholder="Wszystkie kategorie" />
        <FilterSelect testid="results-filter-age" className="min-w-[150px]" value={age} onChange={setAge} options={uniq(inDay.map((g) => g.age_group))} placeholder="Każdy wiek" />
        <button data-testid="results-refresh-btn" onClick={load} className={`${ctl} flex items-center gap-2 hover:border-blue-500`}><RefreshCw className="w-4 h-4" />Odśwież</button>
        <button data-testid="results-csv-btn" onClick={exportCsv} className={`${ctl} flex items-center gap-2 hover:border-blue-500`}><Download className="w-4 h-4" />CSV</button>
        <button data-testid="results-print-btn" onClick={() => window.print()} className={`${ctl} flex items-center gap-2 hover:border-blue-500`}><Printer className="w-4 h-4" />Drukuj</button>
      </div>
      <p className="text-xs text-slate-500 mt-3 no-print">Wynik = suma ocen wszystkich sędziów (część artystyczna + techniczna − odjęcia). Miejsca przyznawane po komplecie ocen; równe sumy dzielą miejsce.</p>
      <div className="grid xl:grid-cols-2 gap-4 mt-4">
        {shown.map((g) => <ResultsGroup key={g.key} g={g} admin judges={judges} onOpen={(e) => setDetail(e.id)} />)}
      </div>
      <ScoreBreakdownDialog pid={detail} onClose={() => setDetail(null)} onChange={load} />
    </div>
  );
};
